import { ALERT_TYPES, NOTIFICATION_STATUS, REMINDER_STATE } from "../../../other/constants/OtherKeys.jsx";
import {getSavedBoardSelection} from "../../../react/hooks/useBoards.jsx";
import {getIsArchivedForBoard} from "../../../other/utils/otherUtils.jsx";

export const ModelEntityReminderStatusMixin = (target) =>
  class extends target {
    static get fields() {
      return [
        { name: "reminderState", persist: false },
        { name: "refreshField", dataSource: "frontend_render"  }
      ]
    }

    get reminderState() {
      // getSavedBoardSelection() can be null for the first user opening application for the first time in browser
      const board = getSavedBoardSelection();
      if (!board) return REMINDER_STATE.NO_REMINDER;
      const isDisplayingArchivedRecords = getIsArchivedForBoard(board.slug);
      // the .alerts is added by Reminder store relation defined in Reminder model
      const remindersOnly = (this.alerts || []).filter((alert) =>
        alert.alertType === ALERT_TYPES.REMINDER
        && alert.alertTag === "Reminder"
        && (isDisplayingArchivedRecords || !alert.archived)
      );

      if (!remindersOnly.length) return REMINDER_STATE.NO_REMINDER;
      const hasUnSentReminder = remindersOnly.some((rec) => rec.status !== NOTIFICATION_STATUS.SENT);
      return hasUnSentReminder ? REMINDER_STATE.NOT_SENT : REMINDER_STATE.SEEN;
    }
  }
